import React from "react";
import {
  useDownloadProjects,
  useDownloadableProjects,
} from "../../projectQueries";
import {
  Typography,
  Button,
  Grid,
  useTheme,
  IconButton,
  Box,
} from "@material-ui/core";
import {
  useTable,
  useSortBy,
  HeaderProps,
  useFilters,
  useRowSelect,
  useGlobalFilter,
  Row,
  usePagination,
} from "react-table";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Alert, AlertTitle } from "@material-ui/lab";
import { generalFilter, useDefaultColumn } from "../../../../util/filter";
import MuiTable from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Container from "@material-ui/core/Container";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ErrorMessage } from "../../../common/ErrorMessage";
import { renderHeader } from "../../../common/util";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useLocations } from "../../../intake/intakeQueries";
import { useQueryClient } from "react-query";
import { getTheme } from "../../../common/getLocalTheme";
import { TravelerModal } from "../../../common/travelerModal";
import { ThreadedViewerReport } from "./threadedViewerReport";
import { useParams } from "react-router-dom";

const dateFormatter = (dateToFormat: Date) => {
  return dateToFormat.toDateString();
};


export const PassedReportTable = ({ passedData, onSelectedRowsChange }: any) => {
  const theme = useTheme();


  const [dataGrid, setDataGrid] = React.useState([]);

  React.useEffect(() => {
    setDataGrid(passedData);
  }, [passedData]);




  const defaultColumn = useDefaultColumn();

  const [noteID, setNoteID] = React.useState(
    Number((useParams() as { note_id: string }).note_id)
  );
  const [open, setOpen] = React.useState(noteID ? true : false);


  const columns = React.useMemo(
    () => [

      {
        Header: "ID",
        accessor: "id",
        filter: generalFilter,
      },
      {
        id: "Serial Number",
        Header: "Serial Number",
        accessor: "unit_serial_number",
        minWidth: 220,
        width: 250,
        Cell: ({ cell }: any) => {
          return <TravelerModal serialNumber={cell.value} />;
        },
      },
      {
        id: "Work Order",
        Header: "Work Order",
        accessor: "work_order_name",
        minWidth: 220,
        width: 250,
        filter: generalFilter,
      },
      {
        id: "Project Number",
        Header: "Project Number",
        accessor: "project_number",
        minWidth: 220,
        width: 250,
        filter: generalFilter,
      },
      {
        id: "Linear Execution Group",
        Header: "Linear Execution Group",
        accessor: "linear_execution_group",
        minWidth: 250,
        width: 250,
        filter: generalFilter,
        Cell: ({ cell }: any) => (
          <Typography>
            {cell.value ? cell.value : "N/A"}
          </Typography>
        ),
      },
      {
        id: "Execution Group Name",
        Header: "Execution Group Name",
        accessor: "name",
        minWidth: 250,
        width: 250,
        filter: generalFilter,
      },

      {
        id: "Procedure Definition Name",
        Header: "Procedure Definition Name",
        accessor: "procedure_definition_name",
        minWidth: 250,
        width: 250,
        filter: generalFilter,
      },
      {
        id: "Date",
        Header: "Date",
        accessor: "start_datetime",
        minWidth: 250,
        width: 250,
        Cell: ({ cell }: any) => {
          return cell.value !== null ? (
            <p>{dateFormatter(new Date(cell.value))}</p>
          ) : (
            <p>N/A</p>
          );
        },
        filter: generalFilter,
      },
      {
        id: "Disposition",
        Header: "Disposition",
        accessor: "disposition_name",
        minWidth: 220,
        width: 250,
        filter: generalFilter,
        Cell: ({ cell }: any) => (
          <Typography
            style={{
              color:
                cell.value?.toLowerCase() === "pass" ||
                  cell.value?.toLowerCase() === "completed"
                  ? "green"
                  : "inherit",
            }}
          >
            {cell.value || "N/A"}
          </Typography>
        ),
      },
      {
        id: "Defect Name",
        Header: "Defect Name",
        accessor: "defect_name",
        minWidth: 220,
        width: 250,
        filter: generalFilter,
        Cell: ({ cell }: any) => (
          <Typography>
            {cell.value ? cell.value : "N/A"}
          </Typography>
        ),
      },
      {
        id: "Test Defiinition Name",
        Header: "Test Defiinition Name",
        accessor: "test_sequence_definition_name",
        minWidth: 220,
        width: 250,
        filter: generalFilter,
      },
      {
        id: "Asset Name",
        Header: "Asset Name",
        accessor: "asset_name",
        minWidth: 220,
        width: 250,
        filter: generalFilter,
      },
      {
        id: "Flag",
        Header: "Flag",
        accessor: "notes[0].subject",
        minWidth: 220,
        width: 250,

        Cell: ({ row }: any) => (
          // <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
          //   <label>{cell.value}</label>
          //   <IconButton
          //     onClick={() => {
          //       setNoteID(cell.value);
          //       setOpen(true);
          //     }}
          //   >
          //     <Icon>visibility</Icon>
          //   </IconButton>
          // </div>


          <Button
            fullWidth
            color="primary"
            onClick={() => {
              setNoteID(row.values.note_id);
              setOpen(true);
            }}
          >
            {row.values.Flag}
          </Button>
        ),

      },

      {
        Header: "note_id",
        accessor: "note_id",
        filter: generalFilter,
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    selectedFlatRows,
    setPageSize,
  } = useTable(
    {
      data: dataGrid,

      columns,
      defaultColumn,
      initialState: {
        hiddenColumns: ["id", "note_id"],
        pageSize: 10000,
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        // Let's make a column for selection
        {
          id: "selection",
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllRowsSelectedProps }: HeaderProps<any>) => (
            <div>
              <Checkbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }: { row: Row<any> }) => (
            <div>
              <Checkbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );


  // Notify parent about selected rows
  React.useEffect(() => {
    if (onSelectedRowsChange) {
      onSelectedRowsChange(selectedFlatRows.map(row => row.original));
    }
  }, [selectedFlatRows, onSelectedRowsChange]);



  return (
    <>


      <TableContainer
        data-testid="tableContainer"
        style={theme.tableContainer}
        component={Paper}
      >
        <MuiTable stickyHeader {...getTableProps()} size="small">
          <TableHead>
            {headerGroups.map((headerGroup) => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <TableCell>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      spacing={0}
                    >
                      <Grid item xs={12} {...column.getHeaderProps()}>
                        <Grid
                          container
                          direction="row"
                          alignItems="center"
                          spacing={0}
                        >
                          <Typography variant="subtitle1">
                            {renderHeader(column)}
                          </Typography>
                          {column.canFilter ? column.render("Filter") : null}
                          <Grid item xs={2}>
                            <IconButton
                              type="submit"
                              aria-label="search"
                              size="small"
                              {...column.getSortByToggleProps()}
                            >
                              {column.isSorted ? (
                                column.isSortedDesc ? (
                                  <ArrowDropDownIcon />
                                ) : (
                                  <ArrowDropUpIcon />
                                )
                              ) : (
                                column.id !== "selection" && <CallSplitIcon />
                              )}
                            </IconButton>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>
          <TableBody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <TableRow {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <TableCell {...cell.getCellProps()}>
                        {cell.render("Cell")}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </MuiTable>
      </TableContainer>




      <Box padding={2}></Box>

      <ThreadedViewerReport id={noteID} open={open} setOpen={setOpen} />


    </>
  );
};

